module.exports = "/assets/data/4a8c8a636ba84192f7f0e53a8e5e9011-NE2.data.json";